import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as actionsUi from './qs-checks.actions.ui';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {UuidService} from '@orga-app/providers/uuid.service';
import {PageState} from './qs-checks.reducer';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {AlertController, IonInput, ModalController, NavController, Platform} from '@ionic/angular';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import {ItemWrapper, ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {FunktionsbereichPruefplaene, Pruefantwort, PruefantwortDetail, Pruefaufgabe, PruefaufgabeAntwort, PruefaufgabeDetail, PruefaufgabeReihenfolgeRequest, Pruefcheckliste, PruefchecklisteDetail, PruefchecklisteReihenfolgeRequest, Pruefobjekt, PruefobjektDetail, Pruefplan, PruefplanDetail} from '../../../clients/qschecks';
import {
    getAktuellenFunktionsbereich,
    getFunktionsbereichePruefplaeneIds,
    getPruefAufgabeAktuell, getPruefAufgabeAktuellFehler, getPruefAufgabeAktuellLaden, getPruefAufgabenIds,
    getPruefAufgabenListe, getPruefAufgabenListeFehler, getPruefAufgabenListeLaden, getPruefAufgabeSelektiert,
    getPruefChecklisteAktuell, getPruefChecklisteAktuellFehler, getPruefChecklisteAktuellLaden, getPruefChecklistenIds,
    getPruefChecklistenListe,
    getPruefChecklistenListeFehler,
    getPruefChecklistenListeLaden,
    getPruefChecklisteSelektiert,
    getPruefobjektAktuell,
    getPruefobjektAktuellFehler,
    getPruefobjektAktuellLaden,
    getPruefobjekteListe,
    getPruefobjekteListeFehler,
    getPruefobjekteListeLaden,
    getPruefobjektSelektiert,
    getPruefplaeneListe,
    getPruefplaeneListeFehler,
    getPruefplaeneListeLaden, getPruefplaeneListeOriginal,
    getPruefplanAktuell,
    getPruefplanAktuellFehler,
    getPruefplanAktuellLaden, getPruefplanAntwortAktuell, getPruefplanAntwortAktuellFehler, getPruefplanAntwortAktuellLaden, getPruefplanAntwortenListe, getPruefplanAntwortenListeFehler, getPruefplanAntwortenListeLaden, getPruefplanAntwortSelektiert,
    getPruefplanSelektiert, getQsControllerRollen, getQsControllerRollenFehler, getQsControllerRollenLaden, getQsControllerRollenLoeschenAktiv, getQsControllerRollenSelected, getQsPrueferRollen, getQsPrueferRollenFehler, getQsPrueferRollenLaden, getQsPrueferRollenLoeschenAktiv, getQsPrueferRollenSelected
} from './qs-checks.selectors';
import {
    AktuellePruefAufgabeSetzenAction,
    AktuellePruefChecklisteSetzenAction,
    AktuellePruefplanAntwortSetzenAction,
    AktuellesPruefobjektSetzenAction,
    NeuePruefAufgabeAction,
    NeuePruefChecklisteAction,
    NeuerPruefplanAction,
    NeuesPruefobjektAction, PruefAufgabeAntwortIstAktivSetzenAction,
    PruefAufgabeBeschreibungSetzenAction,
    PruefAufgabeGewichtungSetzenAction,
    PruefAufgabeIstAktivSetzenAction,
    PruefAufgabeKopierenAction,
    PruefAufgabeLoeschenAction,
    PruefAufgabenLadenAction,
    PruefAufgabeSpeichernAction,
    PruefAufgabeTitelSetzenAction,
    PruefChecklisteBeschreibungSetzenAction,
    PruefChecklisteIstAktivSetzenAction,
    PruefChecklisteKopierenAction,
    PruefChecklisteLoeschenAction,
    PruefChecklistenLadenAction,
    PruefChecklisteSpeichernAction,
    PruefChecklisteTitelSetzenAction,
    PruefobjektBeschreibungSetzenAction,
    PruefobjekteLadenAction,
    PruefobjektIstAktivSetzenAction,
    PruefobjektKopierenAction,
    PruefobjektLoeschenAction,
    PruefobjektSpeichernAction,
    PruefobjektTitelSetzenAction,
    PruefplaeneLadenAction,
    PruefplanAntwortBeschreibungSetzenAction,
    PruefplanAntwortenLadenAction, PruefplanAntwortFarbeSetzenAction,
    PruefplanAntwortGewichtungSetzenAction,
    PruefplanAntwortIconSetzenAction,
    PruefplanAntwortIstAktivSetzenAction,
    PruefplanAntwortIstNaAntwortSetzenAction,
    PruefplanAntwortKuerzelSetzenAction,
    PruefplanAntwortSpeichernAction,
    PruefplanBeschreibungSetzenAction,
    PruefplanIstAktivSetzenAction,
    PruefplanKopierenAction,
    PruefplanLoeschenAction,
    PruefplanSpeichernAction,
    PruefplanTitelSetzenAction, PruefplanZahlerProVTypSetzenAction, QsControllerRollenHinzufuegenAction, QsControllerRollenLadenAction,
    QsControllerRollenSetzenAction, QsPrueferRollenHinzufuegenAction, QsPrueferRollenLadenAction,
    QsPrueferRollenSetzenAction
} from './qs-checks.actions.ui';
import {Funktionsbereich} from '../../../clients/benutzerverwaltung';
import {Datenquelle} from '../rollenselektion/rollenselektion.model';
import {RollenselektionPage} from '../rollenselektion/rollenselektion.page';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {AufgabeIdListeRequest} from '../../../clients/vorlagen';
import {PostAufgabeReihenfolgenAction} from '../../../client-ngrx/vorlagen';
import {PostPruefaufgabeReihenfolgeSetzenAction, PostPruefchecklisteReihenfolgeSetzenAction} from '../../../client-ngrx/qschecks';


@Component({
    selector: 'page-qs-checks',
    templateUrl: 'qs-checks.page.html'
})

export class QsChecksPage implements OnInit, OnDestroy {
    @ViewChild('pruefplanTitelInput', {static: false}) pruefplanTitelInput: IonInput;

    // PRUEFPLAN
    public pruefplaeneListe$: Observable<Array<ListInputItem>>;
    public pruefplaeneListeOriginal$: Observable<Array<FunktionsbereichPruefplaene>>;
    public pruefplaeneListeLaden$: Observable<boolean>;
    public pruefplaeneListeFehler$: Observable<boolean>;
    public pruefplanSelektiert$: Observable<Pruefplan>;
    public pruefplanAktuell$: Observable<PruefplanDetail>;
    public pruefplanAktuellLaden$: Observable<boolean>;
    public pruefplanAktuellFehler$: Observable<boolean>;
    public funktionsbereichePruefplaeneIds$: Observable<Array<string>>;
    public aktuellerFunktionsbereich$: Observable<Funktionsbereich>;

    // PRUEFPLAN ANTWORTEN
    public pruefplanAntwortenListe$: Observable<Array<ListInputItem>>;
    public pruefplanAntwortenListeLaden$: Observable<boolean>;
    public pruefplanAntwortenListeFehler$: Observable<boolean>;
    public pruefplanAntwortSelektiert$: Observable<Pruefantwort>;
    public pruefplanAntwortAktuell$: Observable<PruefantwortDetail>;
    public pruefplanAntwortAktuellLaden$: Observable<boolean>;
    public pruefplanAntwortAktuellFehler$: Observable<boolean>;

    // PRUEFOBJEKT
    public pruefobjekteListe$: Observable<Array<ListInputItem>>;
    public pruefobjekteListeLaden$: Observable<boolean>;
    public pruefobjekteListeFehler$: Observable<boolean>;
    public pruefobjektSelektiert$: Observable<Pruefobjekt>;
    public pruefobjektAktuell$: Observable<PruefobjektDetail>;
    public pruefobjektAktuellLaden$: Observable<boolean>;
    public pruefobjektAktuellFehler$: Observable<boolean>;

    // PRUEF-CHECKLISTE
    public pruefChecklistenListe$: Observable<Array<ListInputItem>>;
    public pruefChecklistenListeLaden$: Observable<boolean>;
    public pruefChecklistenListeFehler$: Observable<boolean>;
    public pruefChecklistenIds$: Observable<Array<string>>;
    public pruefChecklisteSelektiert$: Observable<Pruefcheckliste>;
    public pruefChecklisteAktuell$: Observable<PruefchecklisteDetail>;
    public pruefChecklisteAktuellLaden$: Observable<boolean>;
    public pruefChecklisteAktuellFehler$: Observable<boolean>;

    // PRUEF-AUFGABE
    public pruefAufgabenListe$: Observable<Array<ListInputItem>>;
    public pruefAufgabenListeLaden$: Observable<boolean>;
    public pruefAufgabenListeFehler$: Observable<boolean>;
    public pruefAufgabenIds$: Observable<Array<string>>;
    public pruefAufgabeSelektiert$: Observable<Pruefaufgabe>;
    public pruefAufgabeAktuell$: Observable<PruefaufgabeDetail>;
    public pruefAufgabeAktuellLaden$: Observable<boolean>;
    public pruefAufgabeAktuellFehler$: Observable<boolean>;

    // FREIGABE-, LESE- & ABARBEITUNGS-ROLLEN
    public qsPrueferRollenLoeschenAktiv$: Observable<boolean>;
    public qsPrueferRollenSelected$: Observable<Array<string>>;
    public qsPrueferRollen$: Observable<Array<ListInputItem>>;
    private qsPrueferRollen: Array<ListInputItem>;
    public qsPrueferRollenLaden$: Observable<boolean>;
    public qsPrueferRollenFehler$: Observable<boolean>;

    public qsControllerRollenLoeschenAktiv$: Observable<boolean>;
    public qsControllerRollenSelected$: Observable<Array<string>>;
    public qsControllerRollen$: Observable<Array<ListInputItem>>;
    private qsControllerRollen: Array<ListInputItem>;
    public qsControllerRollenLaden$: Observable<boolean>;
    public qsControllerRollenFehler$: Observable<boolean>;

    // VARIABLEN ZUR ZWISCHENSPEICHERUNG
    aktuellerTab = 'Kopfdaten';
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    private aiName = 'QsChecksPage';

    private unsubscribe$ = new Subject();

    constructor(public navCtrl: NavController,
                public modalCtrl: ModalController,
                private storeMandant: Store<fromMandantModule.MandantState>,
                public platform: Platform,
                private uuid: UuidService,
                private store: Store<PageState>,
                public settingsProvider: SettingsProvider,
                public alertCtrl: AlertController
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
        // this.settings$ = this.settingsProvider.getActiveTheme();
    }

    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        // Prüfpläne
        this.pruefplaeneListe$ = this.store.pipe(select(getPruefplaeneListe));
        this.pruefplaeneListeOriginal$ = this.store.pipe(select(getPruefplaeneListeOriginal));
        this.pruefplaeneListeLaden$ = this.store.pipe(select(getPruefplaeneListeLaden));
        this.pruefplaeneListeFehler$ = this.store.pipe(select(getPruefplaeneListeFehler));
        this.pruefplanSelektiert$ = this.store.pipe(select(getPruefplanSelektiert));
        this.pruefplanAktuell$ = this.store.pipe(select(getPruefplanAktuell));
        this.pruefplanAktuellLaden$ = this.store.pipe(select(getPruefplanAktuellLaden));
        this.pruefplanAktuellFehler$ = this.store.pipe(select(getPruefplanAktuellFehler));
        this.funktionsbereichePruefplaeneIds$ = this.store.pipe(select(getFunktionsbereichePruefplaeneIds));
        this.aktuellerFunktionsbereich$ = this.store.pipe(select(getAktuellenFunktionsbereich));

        // Prüfplan Antworten
        this.pruefplanAntwortenListe$ = this.store.pipe(select(getPruefplanAntwortenListe));
        this.pruefplanAntwortenListeLaden$ = this.store.pipe(select(getPruefplanAntwortenListeLaden));
        this.pruefplanAntwortenListeFehler$ = this.store.pipe(select(getPruefplanAntwortenListeFehler));
        this.pruefplanAntwortSelektiert$ = this.store.pipe(select(getPruefplanAntwortSelektiert));
        this.pruefplanAntwortAktuell$ = this.store.pipe(select(getPruefplanAntwortAktuell));
        this.pruefplanAntwortAktuellLaden$ = this.store.pipe(select(getPruefplanAntwortAktuellLaden));
        this.pruefplanAntwortAktuellFehler$ = this.store.pipe(select(getPruefplanAntwortAktuellFehler));

        // Prüfobjekte
        this.pruefobjekteListe$ = this.store.pipe(select(getPruefobjekteListe));
        this.pruefobjekteListeLaden$ = this.store.pipe(select(getPruefobjekteListeLaden));
        this.pruefobjekteListeFehler$ = this.store.pipe(select(getPruefobjekteListeFehler));
        this.pruefobjektSelektiert$ = this.store.pipe(select(getPruefobjektSelektiert));
        this.pruefobjektAktuell$ = this.store.pipe(select(getPruefobjektAktuell));
        this.pruefobjektAktuellLaden$ = this.store.pipe(select(getPruefobjektAktuellLaden));
        this.pruefobjektAktuellFehler$ = this.store.pipe(select(getPruefobjektAktuellFehler));

        // Prüf-Checklisten
        this.pruefChecklistenListe$ = this.store.pipe(select(getPruefChecklistenListe));
        this.pruefChecklistenListeLaden$ = this.store.pipe(select(getPruefChecklistenListeLaden));
        this.pruefChecklistenListeFehler$ = this.store.pipe(select(getPruefChecklistenListeFehler));
        this.pruefChecklistenIds$ = this.store.pipe(select(getPruefChecklistenIds));
        this.pruefChecklisteSelektiert$ = this.store.pipe(select(getPruefChecklisteSelektiert));
        this.pruefChecklisteAktuell$ = this.store.pipe(select(getPruefChecklisteAktuell));
        this.pruefChecklisteAktuellLaden$ = this.store.pipe(select(getPruefChecklisteAktuellLaden));
        this.pruefChecklisteAktuellFehler$ = this.store.pipe(select(getPruefChecklisteAktuellFehler));

        // Prüf-Aufgaben
        this.pruefAufgabenListe$ = this.store.pipe(select(getPruefAufgabenListe));
        this.pruefAufgabenListeLaden$ = this.store.pipe(select(getPruefAufgabenListeLaden));
        this.pruefAufgabenListeFehler$ = this.store.pipe(select(getPruefAufgabenListeFehler));
        this.pruefAufgabenIds$ = this.store.pipe(select(getPruefAufgabenIds));
        this.pruefAufgabeSelektiert$ = this.store.pipe(select(getPruefAufgabeSelektiert));
        this.pruefAufgabeAktuell$ = this.store.pipe(select(getPruefAufgabeAktuell));
        this.pruefAufgabeAktuellLaden$ = this.store.pipe(select(getPruefAufgabeAktuellLaden));
        this.pruefAufgabeAktuellFehler$ = this.store.pipe(select(getPruefAufgabeAktuellFehler));

        // Rollen / Berechtigungen
        this.qsPrueferRollenLoeschenAktiv$ = this.store.pipe(select(getQsPrueferRollenLoeschenAktiv));
        this.qsPrueferRollen$ = this.store.pipe(select(getQsPrueferRollen));
        this.qsPrueferRollenLaden$ = this.store.pipe(select(getQsPrueferRollenLaden));
        this.qsPrueferRollenFehler$ = this.store.pipe(select(getQsPrueferRollenFehler));
        this.qsPrueferRollenSelected$ = this.store.pipe(select(getQsPrueferRollenSelected));

        this.qsControllerRollenLoeschenAktiv$ = this.store.pipe(select(getQsControllerRollenLoeschenAktiv));
        this.qsControllerRollen$ = this.store.pipe(select(getQsControllerRollen));
        this.qsControllerRollenLaden$ = this.store.pipe(select(getQsControllerRollenLaden));
        this.qsControllerRollenFehler$ = this.store.pipe(select(getQsControllerRollenFehler));
        this.qsControllerRollenSelected$ = this.store.pipe(select(getQsControllerRollenSelected));

        this.qsPrueferRollen$.pipe(takeUntil(this.unsubscribe$)).subscribe(x => this.qsPrueferRollen = x);
        this.qsControllerRollen$.pipe(takeUntil(this.unsubscribe$)).subscribe(x => this.qsControllerRollen = x);
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    async pruefplanLadenSopiListe($event: { pruefplan: Pruefplan, funktionsbereich: Funktionsbereich }) {
        await this.pruefplanLaden($event.pruefplan, $event.funktionsbereich);
    }

    async pruefplanLaden(pruefplan: Pruefplan, funktionsbereich: Funktionsbereich) {
        if (pruefplan != null && pruefplan.pruefplan_id != null) {
            this.store.dispatch(new actionsUi.AktuellenPruefplanSetzenAction(pruefplan));
            setTimeout(() => {
                if (this.pruefplanTitelInput !== null && this.pruefplanTitelInput !== undefined) {
                    this.pruefplanTitelInput.setFocus();
                }
            }, 500);
        }
    }

    pruefplaeneLaden() {
        this.store.dispatch(new PruefplaeneLadenAction());
    }

    pruefplanKopieren() {
        this.store.dispatch(new PruefplanKopierenAction());
    }

    async pruefplanLoeschen() {
        const prompt = await this.alertCtrl.create({
            header: 'ACHTUNG',
            subHeader: 'Soll der Prüfplan wirklich gelöscht werden?',
            message: 'Nach dem Löschen des Prüfplans, fällt dieser auch aus der Auswertung raus. Sollten bereits Daten vorhanden sein, die noch in der Auswertung zur Verfügung stehen sollen, bitte den Prüfplan auf inaktiv schalten.',
            buttons: [
                {
                    text: 'Wirklich löschen!',
                    handler: () => {
                        this.store.dispatch(new PruefplanLoeschenAction());
                    }
                },
                {
                    text: 'Abbrechen',
                    handler: () => {
                    }
                }
            ],
            cssClass: 'alertCustomCss'
        });
        await prompt.present();
    }

    neuerPruefplan(group: Funktionsbereich) {
        this.store.dispatch(new NeuerPruefplanAction(group.funktionsbereich_id));
        this.aktuellerTab = 'Kopfdaten';
    }

    pruefplanTitleSetzen($event: CustomEvent) {
        this.store.dispatch(new PruefplanTitelSetzenAction($event.detail.value));
    }

    pruefplanBeschreibungSetzen($event) {
        this.store.dispatch(new PruefplanBeschreibungSetzenAction($event.detail.value));
    }

    changePruefplanAktiv($event: CustomEvent, pruefplan: Pruefplan) {
        if (pruefplan.ist_aktiv !== $event.detail.checked) {
            this.store.dispatch(new PruefplanIstAktivSetzenAction($event.detail.checked));
        }
    }

    changePruefplanZaehlerProVTyp($event: CustomEvent, pruefplan: PruefplanDetail) {
        if (pruefplan.zaehler_pro_veranstaltungstyp !== $event.detail.checked) {
            this.store.dispatch(new PruefplanZahlerProVTypSetzenAction($event.detail.checked));
        }
    }

    pruefplanSpeichern() {
        this.store.dispatch(new PruefplanSpeichernAction());
    }

    // Prüfantworten
    aktuellePruefantwortSetzen($event: Pruefantwort) {
        this.store.dispatch(new AktuellePruefplanAntwortSetzenAction($event));
    }

    pruefAntwortenLaden() {
        this.store.dispatch(new PruefplanAntwortenLadenAction());
    }

    pruefplanAntwortKuerzelSetzen($event) {
        this.store.dispatch(new PruefplanAntwortKuerzelSetzenAction($event.target.value));
    }

    pruefplanAntwortBeschreibungSetzen($event) {
        this.store.dispatch(new PruefplanAntwortBeschreibungSetzenAction($event.target.value));
    }

    pruefplanAntwortGewichtungSetzen($event) {
        this.store.dispatch(new PruefplanAntwortGewichtungSetzenAction($event.target.value));
    }

    pruefplanAntwortFarbeSetzen($event) {
        this.store.dispatch(new PruefplanAntwortFarbeSetzenAction($event.target.value));
    }

    changeIcon(svg: string) {
        this.store.dispatch(new PruefplanAntwortIconSetzenAction(svg));
    }

    changePruefplanAntwortAktiv($event: CustomEvent, pruefantwort: PruefantwortDetail) {
        if (pruefantwort.ist_aktiv !== $event.detail.checked) {
            this.store.dispatch(new PruefplanAntwortIstAktivSetzenAction($event.detail.checked));
        }
    }

    changePruefplanAntwortNaAntwort($event: CustomEvent, pruefantwort: PruefantwortDetail) {
        if (pruefantwort.ist_na !== $event.detail.checked) {
            this.store.dispatch(new PruefplanAntwortIstNaAntwortSetzenAction($event.detail.checked));
        }
    }

    pruefplanAntwortSpeichern() {
        this.store.dispatch(new PruefplanAntwortSpeichernAction());
    }

    // Prüfobjekte
    pruefobjekteLaden() {
        this.store.dispatch(new PruefobjekteLadenAction());
    }

    pruefobjektKopieren() {
        this.store.dispatch(new PruefobjektKopierenAction());
    }

    async pruefobjektLoeschen() {
        const prompt = await this.alertCtrl.create({
            header: 'ACHTUNG',
            subHeader: 'Soll das Prüfobjekt wirklich gelöscht werden?',
            message: 'Nach dem Löschen des Prüfobjektes, fällt dieser auch aus der Auswertung raus. Sollten bereits Daten vorhanden sein, die noch in der Auswertung zur Verfügung stehen sollen, bitte das Prüfobjekt auf inaktiv schalten.',
            buttons: [
                {
                    text: 'Wirklich löschen!',
                    handler: () => {
                        this.store.dispatch(new PruefobjektLoeschenAction());
                    }
                },
                {
                    text: 'Abbrechen',
                    handler: () => {
                    }
                }
            ],
            cssClass: 'alertCustomCss'
        });
        await prompt.present();
    }

    neuesPruefobjekt() {
        this.store.dispatch(new NeuesPruefobjektAction());
    }

    aktuellesPruefobjektSetzen($event: Pruefobjekt) {
        this.store.dispatch(new AktuellesPruefobjektSetzenAction($event));
    }

    pruefobjektTitleSetzen($event: any) {
        this.store.dispatch(new PruefobjektTitelSetzenAction($event.target.value));
    }

    pruefobjektBeschreibungSetzen($event: any) {
        this.store.dispatch(new PruefobjektBeschreibungSetzenAction($event.target.value));
    }

    changePruefobjektAktiv($event: CustomEvent, pruefobjekt: Pruefobjekt) {
        if (pruefobjekt.ist_aktiv !== $event.detail.checked) {
            this.store.dispatch(new PruefobjektIstAktivSetzenAction($event.detail.checked));
        }
    }

    pruefobjektDetailsSpeichern() {
        this.store.dispatch(new PruefobjektSpeichernAction());
    }

    // Prüf-Checklisten
    pruefChecklistenLaden() {
        this.store.dispatch(new PruefChecklistenLadenAction());
    }

    aktuellePruefChecklisteSetzen($event: any) {
        this.store.dispatch(new AktuellePruefChecklisteSetzenAction($event));
    }

    pruefChecklisteKopieren() {
        this.store.dispatch(new PruefChecklisteKopierenAction());
    }

    async pruefChecklisteLoeschen() {
        const prompt = await this.alertCtrl.create({
            header: 'ACHTUNG',
            subHeader: 'Soll die Checkliste wirklich gelöscht werden?',
            message: 'Nach dem Löschen der Checkliste, fällt diese auch aus der Auswertung raus. Sollten bereits Daten vorhanden sein, die noch in der Auswertung zur Verfügung stehen sollen, bitte die Checkliste auf inaktiv schalten.',
            buttons: [
                {
                    text: 'Wirklich löschen!',
                    handler: () => {
                        this.store.dispatch(new PruefChecklisteLoeschenAction());
                    }
                },
                {
                    text: 'Abbrechen',
                    handler: () => {
                    }
                }
            ],
            cssClass: 'alertCustomCss'
        });
        await prompt.present();

    }

    neuePruefCheckliste() {
        this.store.dispatch(new NeuePruefChecklisteAction());
    }

    pruefChecklisteTitleSetzen($event) {
        this.store.dispatch(new PruefChecklisteTitelSetzenAction($event.target.value));
    }

    pruefChecklisteBeschreibungSetzen($event) {
        this.store.dispatch(new PruefChecklisteBeschreibungSetzenAction($event.target.value));
    }

    changePruefChecklisteAktiv($event: CustomEvent, pruefCheckliste: Pruefcheckliste) {
        if (pruefCheckliste.ist_aktiv !== $event.detail.checked) {
            this.store.dispatch(new PruefChecklisteIstAktivSetzenAction($event.detail.checked));
        }
    }

    pruefChecklisteDetailsSpeichern() {
        this.store.dispatch(new PruefChecklisteSpeichernAction());
    }

    trackByChecklisteItem(index, item: ItemWrapper) {
        return item.id + item.selected;
    }

    async dropInChecklistenListe($event: CdkDragDrop<any>, pruefplan: Pruefplan) {
        await this.dropInChecklistenListeNeu({event: $event, item: null}, pruefplan);
    }

    async dropInChecklistenListeNeu(data: {event: CdkDragDrop<any>, item: any}, pruefplan) {
        const $event = data.event;
        // console.log($event);
        this.pruefChecklistenListe$.subscribe(items => {
            const checklisten = [...items.map(x => x.item)];
            moveItemInArray(checklisten, $event.previousIndex, $event.currentIndex);
            const checklistenIds = checklisten.map(checkliste => checkliste.pruefcheckliste_id);
            const request = <PruefchecklisteReihenfolgeRequest>{
                pruefcheckliste_ids: checklistenIds,
                pruefplan_id: pruefplan.pruefplan_id,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostPruefchecklisteReihenfolgeSetzenAction(request));
        }).unsubscribe();
    }

    // Prüf-Aufgaben
    pruefAufgabenLaden() {
        this.store.dispatch(new PruefAufgabenLadenAction());
    }

    aktuellePruefAufgabeSetzen(pruefaufgabe: Pruefaufgabe) {
        this.store.dispatch(new AktuellePruefAufgabeSetzenAction(pruefaufgabe));
    }

    pruefAufgabeKopieren() {
        this.store.dispatch(new PruefAufgabeKopierenAction());
    }

    pruefAufgabeLoeschen() {
        this.store.dispatch(new PruefAufgabeLoeschenAction());
    }

    neuePruefAufgabe() {
        this.store.dispatch(new NeuePruefAufgabeAction());
    }

    pruefAufgabeTitelSetzen($event) {
        this.store.dispatch(new PruefAufgabeTitelSetzenAction($event.target.value));
    }

    pruefAufgabeBeschreibungSetzen($event) {
        this.store.dispatch(new PruefAufgabeBeschreibungSetzenAction($event.target.value));
    }

    pruefAufgabeGewichtungSetzen($event) {
        this.store.dispatch(new PruefAufgabeGewichtungSetzenAction($event.target.value));
    }

    changePruefAufgabeAktiv($event: CustomEvent, pruefAufgabe: Pruefaufgabe) {
        if (pruefAufgabe.ist_aktiv !== $event.detail.checked) {
            this.store.dispatch(new PruefAufgabeIstAktivSetzenAction($event.detail.checked));
        }
    }

    changePruefAufgabeAntwortAktiv($event: CustomEvent, antwort: PruefaufgabeAntwort) {
        if (antwort.ist_aktiv !== $event.detail.checked) {
            this.store.dispatch(new PruefAufgabeAntwortIstAktivSetzenAction($event.detail.checked, antwort.pruefantwort));
        }
    }

    pruefAufgabeSpeichern() {
        this.store.dispatch(new PruefAufgabeSpeichernAction());
    }

    trackByAufgabeItem(index, item: ItemWrapper) {
        return item.id + item.selected;
    }

    async dropInAufgabenListe($event: CdkDragDrop<any>, pruefplan: Pruefplan) {
        await this.dropInAufgabenListeNeu({event: $event, item: null}, pruefplan);
    }

    async dropInAufgabenListeNeu(data: {event: CdkDragDrop<any>, item: any}, pruefplan) {
        const $event = data.event;
        console.log($event);
        this.pruefAufgabenListe$.subscribe(items => {
            const aufgaben = [...items.map(x => x.item)];
            if (aufgaben.length > 0) {
                moveItemInArray(aufgaben, $event.previousIndex, $event.currentIndex);
                const aufgabenIds = aufgaben.map(aufgabe => aufgabe.pruefaufgabe_id);
                const request = <PruefaufgabeReihenfolgeRequest>{
                    pruefaufgabe_ids: aufgabenIds,
                    pruefcheckliste_id: aufgaben[0].pruefcheckliste_id,
                    pruefplan_id: pruefplan.pruefplan_id,
                    zeitpunkt_utc: new Date(Date.now())
                };
                this.store.dispatch(new PostPruefaufgabeReihenfolgeSetzenAction(request));
            }
        }).unsubscribe();
    }

    // Berechtigungen
    qsPrueferRollenLaden() {
        this.store.dispatch(new QsPrueferRollenLadenAction());
    }

    qsPrueferBerechtigungFuerRolleLoeschen() {
        this.store.dispatch(new actionsUi.QsPrueferRollenLoeschenAction());
    }

    async qsPrueferBerechtigungRollenAuswahl(pruefplan: Pruefplan, funktionsbereich: Funktionsbereich) {
        if (this.pruefplanAktuell$ != null) {
            const rollenIds: Array<string> = [];
            this.qsPrueferRollen.forEach(rolle => rollenIds.push(rolle.item.rolle_id));
            const params = {
                titel: pruefplan.titel,
                nichtAnzuzeigendeRollenIds: rollenIds,
                funktionsbereich: funktionsbereich,
                untertitel: 'Prüfer-Berechtigung',
                alleAnzeigenAuswahlAnzeigen: true,
                alleAnzeigen: false,
                datenquelle: Datenquelle.QsChecks
            };
            // console.log('Params: ', params);
            const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    // console.log('REsult: ', result);
                    result.data.ausgewaehlteRollen.forEach((x: string) => {
                        this.store.dispatch(new QsPrueferRollenHinzufuegenAction(result.data.ausgewaehlteRollen));
                    });
                }
            });

            await modal.present();
        }
    }

    qsPrueferRollenSelectionChanged($event: Array<string>) {
        this.store.dispatch(new QsPrueferRollenSetzenAction($event));
    }

    qsControllerRollenLaden() {
        this.store.dispatch(new QsControllerRollenLadenAction());
    }

    qsControllerBerechtigungFuerRolleLoeschen() {
        this.store.dispatch(new actionsUi.QsControllerRollenLoeschenAction());
    }

    async qsControllerBerechtigungRollenAuswahl(pruefplan: Pruefplan, funktionsbereich: Funktionsbereich) {
        if (this.pruefplanAktuell$ != null) {
            const rollenIds: Array<string> = [];
            this.qsControllerRollen.forEach(rolle => rollenIds.push(rolle.item.rolle_id));
            const params = {
                titel: pruefplan.titel,
                nichtAnzuzeigendeRollenIds: rollenIds,
                funktionsbereich: funktionsbereich,
                untertitel: 'Controller-Berechtigung',
                alleAnzeigenAuswahlAnzeigen: true,
                alleAnzeigen: false,
                datenquelle: Datenquelle.QsChecks
            };
            // console.log('Params: ', params);
            const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    // console.log('REsult: ', result);
                    result.data.ausgewaehlteRollen.forEach((x: string) => {
                        this.store.dispatch(new QsControllerRollenHinzufuegenAction(result.data.ausgewaehlteRollen));
                    });
                }
            });

            await modal.present();
        }
    }

    qsControllerRollenSelectionChanged($event: Array<string>) {
        this.store.dispatch(new QsControllerRollenSetzenAction($event));
    }

}
